import React from 'react';

const ReturnArrowChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 7.8V11H8.7V7l-5 5 5 5v-3.9h11V7.8z"
        />
    </svg>
);

ReturnArrowChunkySvg.displayName = 'ReturnArrowChunkySvg';
export default ReturnArrowChunkySvg;
